import React, { Component } from 'react';

class FontsMetadata extends Component {
    render() {
        return (
            <div>
                <h2> Tipos de Letra </h2>
                <p>
                    Nesta página pode carregar tipos de letra personalizados para utilização nos horários.
                </p>
                <h3>Funcionalidades disponíveis</h3>
                <ul className="bulleted-list">
                    <li>Carregar um Tipo de Letra</li>
                    <li>Visualizar a listagem de todos os Tipos de Letra carregados.</li>
                    <li>Alterar o número de Tipos de Letra mostrados por página.</li>
                </ul>
            </div>
        );
    }
}
export default FontsMetadata;
